import { render } from "./SellerReviews.vue?vue&type=template&id=6010d488&scoped=true"
import script from "./SellerReviews.vue?vue&type=script&lang=js"
export * from "./SellerReviews.vue?vue&type=script&lang=js"

import "./SellerReviews.vue?vue&type=style&index=0&id=6010d488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6010d488"]])

export default __exports__